import { ClaimReviewProvider } from './ClaimReviewProvider';
import ClaimDetail from './components/claimDetails/ClaimDetail';
import { ClaimLineageAlert } from './components/ClaimLineageAlert';
import ClaimLineItemList from './components/ClaimLineItemList';
import ClaimPage from './components/ClaimPage';
import ClaimTimeline from './components/ClaimTimeline';
import ClaimSummary from './components/summary/ClaimSummary';

// ! order should only be able to have a shipping claim following the same pattern in the customer UI.. IE... it has wasShippingProtected = true or isUnprotectedOrderClaimPermitted = true

/** Orchestrates all the claim components together for rendering within the context. */
export default function ClaimReviewPage() {
  return (
    <ClaimReviewProvider>
      <ClaimPage>
        <ClaimLineageAlert />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-[3fr_1fr]">
          <div className="space-y-4">
            <ClaimSummary />
            <ClaimLineItemList />
            <ClaimTimeline />
          </div>
          <div className="space-y-4">
            <ClaimDetail />
          </div>
        </div>
      </ClaimPage>
    </ClaimReviewProvider>
  );
}
